import { StyledAutoFixHighIcon } from "@/shared/ui/ai-button/AiIcon";
import { SharedAiButtonStyles } from "@/shared/ui/ai-button/AiStyles";
import { ButtonProps, styled } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { useContext } from "react";

import { Language } from "@/model/Language/Language";

import { TranslationContext } from "@/app/providers";

import { GetLanguageValueAsString } from "@/app/application/Translate";


const StyledAiButton = styled(IconButton, {
	shouldForwardProp: (prop) => prop !== "loading",
})<ButtonProps & { loading?: boolean }>(({ loading }) =>
	SharedAiButtonStyles(loading),
);

type Props = {
	loading: boolean;
	onClick: () => void;
};

export const AiIconButton = ({ loading, onClick }: Props) => {

	const translation: Language | null = useContext(TranslationContext);
	return (
		<StyledAiButton aria-label={GetLanguageValueAsString(translation, "Auto.Shared.Ui.AiButton.AiIconButton.L18C29.AIFunction", "AI Function")} size="small" onClick={onClick}>
			<StyledAutoFixHighIcon loading={loading} fontSize="small" />
		</StyledAiButton>
	);
};

